"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollapseIcon = function CollapseIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: (className || '') + '',
    focusable: false,
    height: "9",
    role: "presentation",
    viewBox: "0 0 16 9",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.2734 8.97656L8 1.71094L0.726563 8.97656L0.0234375 8.27344L8 0.289062L15.9766 8.27344L15.2734 8.97656Z"
  }));
};

CollapseIcon.defaultProps = {
  className: undefined
};
CollapseIcon.propTypes = {
  className: _propTypes.default.string
};
var _default = CollapseIcon;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Ub2FzdC9Db2xsYXBzZUljb24uanMiXSwibmFtZXMiOlsiQ29sbGFwc2VJY29uIiwiY2xhc3NOYW1lIiwiZGVmYXVsdFByb3BzIiwidW5kZWZpbmVkIiwicHJvcFR5cGVzIiwiUHJvcFR5cGVzIiwic3RyaW5nIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBQ0E7Ozs7QUFFQSxJQUFNQSxZQUFZLEdBQUcsU0FBZkEsWUFBZTtBQUFBLE1BQUdDLFNBQUgsUUFBR0EsU0FBSDtBQUFBLHNCQUNuQjtBQUNFLElBQUEsU0FBUyxFQUFFLENBQUNBLFNBQVMsSUFBSSxFQUFkLElBQW9CLEVBRGpDO0FBRUUsSUFBQSxTQUFTLEVBQUUsS0FGYjtBQUdFLElBQUEsTUFBTSxFQUFDLEdBSFQ7QUFJRSxJQUFBLElBQUksRUFBQyxjQUpQO0FBS0UsSUFBQSxPQUFPLEVBQUMsVUFMVjtBQU1FLElBQUEsS0FBSyxFQUFDLElBTlI7QUFPRSxJQUFBLEtBQUssRUFBQztBQVBSLGtCQVNFO0FBQU0sSUFBQSxDQUFDLEVBQUM7QUFBUixJQVRGLENBRG1CO0FBQUEsQ0FBckI7O0FBY0FELFlBQVksQ0FBQ0UsWUFBYixHQUE0QjtBQUMxQkQsRUFBQUEsU0FBUyxFQUFFRTtBQURlLENBQTVCO0FBSUFILFlBQVksQ0FBQ0ksU0FBYixHQUF5QjtBQUN2QkgsRUFBQUEsU0FBUyxFQUFFSSxtQkFBVUM7QUFERSxDQUF6QjtlQUllTixZIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuY29uc3QgQ29sbGFwc2VJY29uID0gKHsgY2xhc3NOYW1lIH0pID0+IChcbiAgPHN2Z1xuICAgIGNsYXNzTmFtZT17KGNsYXNzTmFtZSB8fCAnJykgKyAnJ31cbiAgICBmb2N1c2FibGU9e2ZhbHNlfVxuICAgIGhlaWdodD1cIjlcIlxuICAgIHJvbGU9XCJwcmVzZW50YXRpb25cIlxuICAgIHZpZXdCb3g9XCIwIDAgMTYgOVwiXG4gICAgd2lkdGg9XCIxNlwiXG4gICAgeG1sbnM9XCJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Z1wiXG4gID5cbiAgICA8cGF0aCBkPVwiTTE1LjI3MzQgOC45NzY1Nkw4IDEuNzEwOTRMMC43MjY1NjMgOC45NzY1NkwwLjAyMzQzNzUgOC4yNzM0NEw4IDAuMjg5MDYyTDE1Ljk3NjYgOC4yNzM0NEwxNS4yNzM0IDguOTc2NTZaXCIgLz5cbiAgPC9zdmc+XG4pO1xuXG5Db2xsYXBzZUljb24uZGVmYXVsdFByb3BzID0ge1xuICBjbGFzc05hbWU6IHVuZGVmaW5lZFxufTtcblxuQ29sbGFwc2VJY29uLnByb3BUeXBlcyA9IHtcbiAgY2xhc3NOYW1lOiBQcm9wVHlwZXMuc3RyaW5nXG59O1xuXG5leHBvcnQgZGVmYXVsdCBDb2xsYXBzZUljb247XG4iXX0=